function getFiltersState(state) {
  return {
    headerFilter: state.postingStatisticsFilter.filter,
    startFilter: state.postingStatisticsFilter.filterStartPeriod,
    endFilter: state.postingStatisticsFilter.filterEndPeriod
  };
}

export { getFiltersState };
